import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType, mapToFormData } from '../../../common';

export const createUser = (data: PropertyType): Promise<PropertyType> =>
	api.post('/user/create', mapToFormData(mapEntityToApi(data)), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data.data);
	});
